import {
  GEARS4_LOADING,
  TRICKSTRAT_LOADING
} from "./loadingArrays.js";

module.exports.getRandomLoading = function(num) {
    var arr = TRICKSTRAT_LOADING;
    var text = arr[num.toString()];
    return text;
}

module.exports.getRandomGearsLoading = function(num) {
    var arr = GEARS4_LOADING;
    var text = arr[num.toString()];
    return text;
}



// WEBPACK FOOTER //
// ./src/app/utils/loading/loadingUtils.js